import { render } from "./BoxRank.vue?vue&type=template&id=3d24f700&scoped=true"
import script from "./BoxRank.vue?vue&type=script&lang=js"
export * from "./BoxRank.vue?vue&type=script&lang=js"

import "./BoxRank.vue?vue&type=style&index=0&id=3d24f700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d24f700"]])

export default __exports__